export default {
  navbar: {
    home: '首页',
    smartSearch: '智能搜索',
    tagSearch: '标签搜索',
    drawCar: '画了个车',
    more: '更多',
    articles: '资讯',
    inspiration: '灵感',
    forum: '论坛',
    upload: '上传',
    about: '关于',
    menu: '菜单',
    login: '登录',
    register: '注册',
    searchPlaceholderMobile: '搜索品牌或车型',
    searchPlaceholderDesktop: '搜索您感兴趣的汽车品牌或车型',
    myPoints: '我的积分',
    profile: '个人资料',
    myFavorites: '我的收藏',
    myUploads: '我的上传',
    tagManagement: '图片标签管理',
    galleryBrowser: '图片分类浏览',
    logout: '退出登录'
  },
  home: {
    latestUpload: '最新上传',
    viewDetails: '查看详情',
    noImage: '暂无图片',
    loadingLatestModels: '加载最新上传的车型...',
    brandNav: '品牌导航',
    allBrands: '全部品牌',
    domesticBrands: '国内品牌',
    overseasBrands: '海外品牌',
    all: '全部',
    any: '不限',
    noBrandsFound: '没有找到符合条件的品牌',
    totalBrands: '共 {count} 个品牌',
    conceptCars: '概念车',
    newestFirst: '新车优先',
    oldestFirst: '老车优先',
    latestUploadSort: '最新上传',
    loadingModels: '加载车型数据...',
    noModelsFound: '暂无车型数据',
    loadingMoreModels: '正在加载更多车型...',
    allModelsLoaded: '已加载全部车型',
    modelName: '车型名称',
    unknownBrand: '未知品牌',
    latestUploadedModels: '最新上传的车型',
    discoverHighDef: '浏览中国自主品牌最新车型的官方高清图片',
    professionalGallery: '专业车辆图库',
    discoverTenThousand: '发现超过10,000张高清汽车官方图片',
    panoramicView: '360°全景查看',
    experienceDetails: '体验车辆内外的细节',
    retry: '重试',
    loadingModelData: '加载车型数据...',
    brandDetails: '品牌详情',
    carModelDetails: '车型详情',
    thanksFeedback: '感谢您的反馈！我们会认真考虑您的建议。'
  },
  modelDetail: {
    selectType: '选择车型类型',
    noImages: '暂无符合条件的图片',
    allImages: '全部图片',
    exterior: '外观',
    interior: '内饰',
    detail: '细节',
    specs: '基本参数',
    description: '车型描述',
    price: '指导价格',
    param: '参数',
    brand: '品牌',
    year: '年',
    updateSuccess: '车型类型更新成功',
    updateFailed: '车型类型更新失败',
    orderSaved: '图片顺序已保存',
    orderSaveFailed: '保存图片顺序失败',
    orderSaveRetry: '保存图片顺序失败，请重试',
    typeAlreadySet: '当前车型类型已经是 {type}，无需更新',
    fetchFailed: '获取车型数据失败'
  },
  imageGallery: {
    totalImages: '总图片数',
    filteredCount: '筛选结果',
    currentPageCount: '当前页',
    filterTitle: '筛选条件',
    modelCategory: '车型分类',
    allTypes: '全部类型',
    brand: '品牌',
    allBrands: '全部品牌',
    modelType: '车型类型',
    allModels: '全部车型',
    conceptCar: '概念车',
    exteriorStyle: '外型风格',
    allExteriorStyles: '全部外型风格',
    interiorStyle: '内饰风格',
    allInteriorStyles: '全部内饰风格',
    tagSearch: '标签搜索',
    tagSearchPlaceholder: '输入标签关键词',
    popularTags: '热门标签',
    clearFilters: '清除筛选',
    applyFilters: '应用筛选',
    loadingImages: '正在加载图片...',
    loadingSubtitle: '请稍候，正在为您准备精彩内容',
    noImages: '暂无图片',
    noImagesDesc: '当前筛选条件下没有找到图片，请尝试调整筛选条件',
    unknownModel: '未知车型',
    unknownType: '未知类型',
    loadingMore: '加载更多图片...'
  },
  about: {
    subtitle1: 'CarDesignSpace 是全球汽车设计爱好者的灵感库与创意社区，',
    subtitle2: '我们因热爱而汇聚于此。',
    createTitle: 'CREATE · 创造发现',
    createDesc: '我们持续聚合全球杰出汽车设计，从经典杰作到前沿概念，为你构建一座探索设计演进的在线博物馆。',
    designTitle: 'DESIGN · 设计收藏',
    designDesc: '以设计视角重构分类体系，通过精准的品牌、车型、年代与风格标签，助你高效构建个人灵感库。',
    shareTitle: 'SHARE · 分享启迪',
    shareDesc: '这是一个自由共创的社区。我们鼓励分享、对话与碰撞，让每一个灵感点亮更多创意可能。',
    followTitle: '更多精彩内容，敬请关注',
    followSubtitle: '微信公众号 | 微信小程序',
    wechatOfficial: '微信公众号',
    wechatMini: '微信小程序',
    wechatOfficialDesc: '扫码关注，获取最新资讯',
    wechatMiniDesc: '扫码使用，随时随地浏览',
    pageTitle: '关于我们'
  },
  profile: {
    editProfile: '编辑资料',
    posts: '帖子',
    likes: '获赞',
    points: '积分',
    myPosts: '我的帖子',
    shareSomething: '分享新鲜事...',
    allPosts: '全部帖子',
    popularPosts: '热门帖子',
    delete: '删除',
    likesReceived: '获赞',
    comments: '评论',
    viewDetails: '点击查看详情',
    noPostsSelf: '还没有发布过帖子',
    noPostsUser: '该用户还没有发布过帖子',
    firstPostPrompt: '分享你的第一条动态吧！',
    publishFirstPost: '发布第一条帖子',
    loadMore: '加载更多',
    likeRecords: '获赞记录',
    likedYourPost: '赞了你的帖子',
    viewPostDetails: '点击查看帖子详情',
    noLikes: '还没有获得点赞',
    noLikesPrompt: '发布优质内容来获得更多点赞吧！',
    goToForum: '去发帖',
    myFavorites: '我的收藏',
    favoritePosts: '收藏帖子',
    favoritedAt: '收藏于',
    removeFavorite: '取消收藏',
    noFavorites: '还没有收藏过帖子',
    noFavoritesPrompt: '去论坛收藏感兴趣的帖子吧！',
    browseForum: '浏览论坛'
  },
  common: {
    confirm: '确定',
    cancel: '取消',
    tips: '提示',
    loading: '加载中...',
    loginExpired: '登录已过期，请重新登录',
    operationFailed: '操作失败，请重试',
    welcomeBack: '欢迎回来，{name}！',
    logoutSuccess: '已退出登录',
    logoutConfirm: '确定要退出登录吗？'
  }
}
